import React from "react";
import { getCurrentYear } from "../../utils/dateUtils";

const FooterCopyright = () => {
  const year = getCurrentYear();
  const text = `جميع الحقوق محفوطة لوزارة التنمية الإدارية في الجمهورية العربية السورية © ${year}`;

  return (
    <div
      className="
        w-full text-center sm:text-left
        text-[10px] sm:text-xs md:text-sm
        text-light opacity-80
        mt-2 sm:mt-0
        pb-2 sm:pb-0
      "
    >
      {text}
    </div>
  );
};

export default FooterCopyright;
